import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PublicFooterProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Trust strip for public pages: chrome surface, subtle top edge,
 * secure-portal caption with a shield icon.
 */
const PublicFooter: React.FC<PublicFooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();

  return (
    <footer
      className={`w-full border-t border-edge-subtle bg-chrome backdrop-blur-md safe-area-bottom ${className}`}
    >
      {children || (
        <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-3 @bp-sm:px-6 @bp-lg:px-8">
          <ShieldCheck className="size-4 shrink-0 text-success" aria-hidden />
          <span className="font-ui text-small font-medium text-tertiary">
            {t('authenticatedFooter.securePortal', 'Secure portal')}
          </span>
        </div>
      )}
    </footer>
  );
};

export default PublicFooter;
